import {
  call,
  cancel,
  fork,
  put,
  race,
  select,
  take,
} from 'redux-saga/effects';
import { expendRecaptcha } from 'redux/actions/recaptchaActions';
import { requestRecaptchaToken } from 'redux/sagas/recaptcha/requestRecaptcha';
import { uploadedPicturesSelector } from 'redux/selectors/picture';
import { SET_RECAPTCHA, SET_RECAPTCHA_ERROR } from 'redux/actions/types';
import { addErrorAlert, addSuccessAlert } from 'redux/actions/alertActions';
import {
  bugReportingDistributionListSelector,
  partnerSelector,
} from 'redux/selectors/config';
import { reportBugToBackend } from 'api/reportABug/reportABug';
import {
  reportABugFail,
  reportABugSuccess,
} from 'redux/actions/reportABugActions';

export function* reportABug({
  payload: { errorMessage, message, successMessage },
}) {
  try {
    const uploadedScreenshots = yield select(
      uploadedPicturesSelector('bugReporting'),
    );
    const reduxState = yield select(state => state);
    const recipients = yield select(bugReportingDistributionListSelector);
    const partner = yield select(partnerSelector);

    yield call(prepareEveryCall, {
      errorMessage,
      message: { message, reduxState },
      partner,
      picture: uploadedScreenshots[0],
      recipients,
      successMessage,
    });
  } catch (err) {
    yield errorMessage && put(addErrorAlert({ message: errorMessage }));
    yield put(reportABugFail(err));
  }
}

export function* prepareEveryCall({
  errorMessage,
  message,
  partner,
  picture,
  recipients,
  successMessage,
}) {
  const task = yield fork(requestRecaptchaToken);
  const { token, error } = yield race({
    token: take(SET_RECAPTCHA),
    error: take(SET_RECAPTCHA_ERROR),
  });
  if (error) {
    yield cancel(task);
    return;
  }
  yield put(expendRecaptcha());
  const { id, name, type } = picture;

  const { status } = yield call(reportBugToBackend, {
    message,
    partner,
    picture: { id, name, type },
    recaptchaToken: token.payload,
    recipients,
  });

  if (status === 201 || status === 200) {
    yield successMessage && put(addSuccessAlert(successMessage));
    yield put(reportABugSuccess());
  } else {
    yield errorMessage && put(addErrorAlert({ message: errorMessage }));
    yield put(reportABugFail());
  }
}
